<template>
  <div
    class="sticky top-0 z-[2010] flex w-full items-center justify-center gap-2.5 bg-linear-to-r from-red-600 to-red-700 px-6 py-3 text-center text-sm font-semibold leading-snug tracking-wide text-white shadow-md"
    data-cy="uncertified-version-banner"
    role="alert"
  >
    <svg
      class="h-5 w-5 shrink-0"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <span>{{ t("compliance.uncertified-version-warning") }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";

/**
 * Persistent, non-dismissible warning shown to French groups still running
 * the old, uncertified POS version (FIS-405). Rendered below the navbar and
 * kept sticky so it never scrolls out of view.
 */
export default defineComponent({
  name: "UncertifiedVersionBanner",
  setup() {
    const { t } = useI18n({});
    return { t };
  },
});
</script>
